// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectSession,
    selectCurrentGame,
} from '../../../features/session/sessionSlice';

// Components
import Game from '../../screens/Game/Game';
import PatternWon from '../../screens/PatternWon/PatternWon';
import GameWon from '../../screens/GameWon/GameWon';
import GameOver from '../../screens/GameOver/GameOver';
import GameStarting from '../../screens/GameStarting/GameStarting';
import SessionOver from '../../screens/SessionOver/SessionOver';
import SessionClosed from '../../screens/SessionClosed/SessionClosed';
import SessionStarting from '../../screens/SessionStarting/SessionStarting';

/**
 * @function Session
 * The Session template
 *
 * @example
 * return (
 *   <Session />
 * )
 */
function Session() {
    const session = useAppSelector(selectSession);
    const game = useAppSelector(selectCurrentGame);

    function renderScreen() {
        if (session === null || session === undefined) {
            return <></>;
        }

        switch (session.state) {
            case 'pending':
                return <SessionStarting />;
            case 'open':
                switch (game.state) {
                    case 'pending':
                        return <GameStarting />;
                    case 'open':
                        return <Game />;
                    case 'pattern_won':
                        return <PatternWon />;
                    case 'game_won':
                        return <GameWon />;
                    case 'closed':
                        return <GameOver />;
                    case 'none':
                    default:
                        return <SessionStarting />;
                }
            case 'complete':
                return <SessionOver />;
            case 'closed':
            default:
                return <SessionClosed />;
        }
    }

    return renderScreen();
}

// Exports
export default Session;
